import { InlineAlertType } from '@varo/graphql-schema-types';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { type PaymentPlanReviewLink } from 'shared/components/lending/paymentPlanReview/PaymentPlanReviewLayout/PaymentPlanReviewLayout';
import InlineAlert from 'shared/components/vxl/InlineAlert/InlineAlert';
import Checkbox from 'shared/components/vxl/selection/Checkbox/Checkbox';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import HyperlinkBaseText from 'shared/components/vxl/typography/primary/hyperlink/HyperlinkBaseText';
import theme from 'shared/styles/theme';

interface PaymentPlanAgreementProps {
  isAgreed: boolean;
  onAgreementChange: () => void;
  checkboxAnalyticsId?: string;
  documentLink: PaymentPlanReviewLink;
  notice: string;
}

const PaymentPlanAgreement = ({
  isAgreed,
  onAgreementChange,
  checkboxAnalyticsId,
  documentLink,
  notice,
}: PaymentPlanAgreementProps) => {
  const { t: translatedText } = useTranslation('lending', {
    keyPrefix: 'paymentPlanReview',
  });

  return (
    <View style={styles.container}>
      <Checkbox
        checked={isAgreed}
        onSelectedStateChange={onAgreementChange}
        analyticsId={checkboxAnalyticsId}
      >
        <View style={styles.textContainer}>
          <BodyBaseText>
            {translatedText('agreeToTerms')}{' '}
            <HyperlinkBaseText
              onPress={documentLink.onPress}
              analyticsId={documentLink.analyticsId}
            >
              {documentLink.label}
            </HyperlinkBaseText>
          </BodyBaseText>
        </View>
      </Checkbox>
      <View style={styles.notice}>
        <InlineAlert
          alertType={InlineAlertType.Info}
          bodyText={notice}
          isImageVisible={false}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { paddingHorizontal: theme.spacing.m },
  notice: { paddingBottom: theme.spacing.m, paddingTop: theme.spacing.s },
  textContainer: { flex: 1 },
});

export default PaymentPlanAgreement;
